import Detail from '@components/LocalMerchant/AtlasManage/Detail'
import { asyncLoad } from '@util'

const AsyncManage = asyncLoad(() =>
  import('@components/LocalMerchant/AtlasManage/Manage')
)

export default {
  path: 'atlasManage',
  indexRoute: {
    component: AsyncManage
  },
  stat: '转介绍图集管理/首页',
  childRoutes: [
    {
      path: 'detail(/:id)',
      component: Detail,
      stat: '转介绍图集管理/编辑图集'
    }
  ]
}
